export const SEARCH_HOMEOWNER_ASYNC = 'SEARCH_HOMEOWNER_ASYNC';
export const SEARCH_HOMEOWNER_SUCCESS = 'SEARCH_HOMEOWNER_SUCCESS';

export const SEARCH_WORK_ORDERS_ASYNC = 'SEARCH_WORK_ORDERS_ASYNC';
export const SEARCH_WORK_ORDERS_SUCCESS = 'SEARCH_WORK_ORDERS_SUCCESS';

export const SEARCH_REQUEST_FOR_SERVICE_ASYNC = 'SEARCH_REQUEST_FOR_SERVICE_ASYNC';
export const SEARCH_REQUEST_FOR_SERVICE_SUCCESS = 'SEARCH_REQUEST_FOR_SERVICE_SUCCESS';

export const RESET_SEARCH_RESULT = 'RESET_SEARCH_RESULT';



// WEBPACK FOOTER //
// ./src/Search/constants.js